import React, { useState } from "react";
import AddCircleOutline from "@material-ui/icons/AddCircleOutline";
import { Dropdown } from "@sonder/ui/source/styled/components/Dropdown";
import { Button } from "@sonder/ui/source/styled/fragments/Button";
import {
  FilterButtonList,
  FilterDropdownContent,
  FilterEmpty,
  FilterTextArea,
} from "@sonder/ui/source/styled/fragments/GenericFilters";
import { useStore as useAuthStore } from "auth/store";
import { BuildingsData } from "core/queries/GetBuildingSupervisors";
import { UserData, useSearchForUsers } from "core/queries/SearchForUsers";
import { AddSupervisorGroupItem } from "supervisors/components/AddSupervisorGroupItem";

interface AddSupervisorButtonProps {
  building: BuildingsData;
}

export const AddSupervisorButton = ({ building }: AddSupervisorButtonProps) => {
  const { state: authState } = useAuthStore();
  const [searchTerm, setSearchTerm] = useState("");

  const { data, loading } = useSearchForUsers({
    skip: searchTerm === "",
    variables: {
      searchTerm,
    },
  });

  const users = data?.searchWithMetadata.items.map(item => item.resource) || [];
  const isEmpty = users.length === 0;
  const isEmptyAndLoading = isEmpty && loading;
  const isEmptyAndSearched = !loading && isEmpty && searchTerm !== "";

  const isDispatchDashboardAdmin = authState.user?.isDispatchDashboardAdmin;
  if (!isDispatchDashboardAdmin) {
    return null;
  }

  return (
    <Dropdown
      trigger={
        <Button fullWidth iconLeft type="button">
          <AddCircleOutline />
          Add Supervisor
        </Button>
      }
    >
      {({ isOpen: isPortalOpen, closePortal }) =>
        isPortalOpen && (
          <FilterDropdownContent align="left">
            <FilterTextArea
              autoFocus
              placeholder="Search for users"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
            {isEmptyAndLoading && <FilterEmpty>Searching...</FilterEmpty>}
            {isEmptyAndSearched && (
              <FilterEmpty>{`No Results for ${searchTerm}.`}</FilterEmpty>
            )}
            <FilterButtonList>
              {users
                .filter(u => u.__typename === "User")
                .map(u => {
                  const user = u as UserData;
                  return (
                    <AddSupervisorGroupItem
                      building={building}
                      closePortal={closePortal}
                      key={user.id}
                      user={user}
                    />
                  );
                })}
            </FilterButtonList>
          </FilterDropdownContent>
        )
      }
    </Dropdown>
  );
};
